/**
 * Shared Services Layer
 *
 * High-level services and utilities shared across the application.
 *
 * @remarks
 * This module provides application-level services:
 * - Query state management for data fetching
 * - Page controller types for page-level logic
 */

// ============================================================================
// Query State Management
// ============================================================================
export {QueryState} from "./query-state";
export type {QueryStateInstance} from "./query-state";

// ============================================================================
// Page Controller Types
// ============================================================================
export type {PageParams, SearchParams, PageControllerContext, ResolvedPageControllerContext} from "./page-controller";

// ============================================================================
// Analytics Service
// Import directly from "@/shared/services/analytics/analytics.service"
// ============================================================================
